module.exports = __webpack_public_path__ + "img/美型前.0841dda3.jpg";